// extracted by mini-css-extract-plugin
module.exports = {"amgfren":"amgfren"};